import ArticleSplitHero from './ArticleSplitHero'

export default ArticleSplitHero